import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface AnnouncementData {
  enabled: boolean;
  text: string;
  link?: string;
}

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState<AnnouncementData | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const loadAnnouncement = async () => {
      const { data, error } = await (supabase as any)
        .from("site_settings")
        .select("value")
        .eq("id", "announcement")
        .single();

      if (!error && data) {
        setAnnouncement(data.value as AnnouncementData);
      }
    };

    loadAnnouncement();

    const channel = supabase
      .channel("site_settings_changes")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "site_settings", filter: "id=eq.announcement" },
        (payload: any) => {
          if (payload.new && payload.new.value) {
            setAnnouncement(payload.new.value as AnnouncementData);
            setDismissed(false);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  if (!announcement?.enabled || !announcement.text || dismissed) {
    return null;
  }

  return (
    <div className="bg-primary text-primary-foreground py-3 px-4 text-center text-base font-bold relative z-50">
      <div className="container mx-auto flex items-center justify-center gap-3">
        {announcement.link ? (
          <a 
            href={announcement.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:underline font-bold"
          >
            {announcement.text}
          </a>
        ) : (
          <span className="font-bold">{announcement.text}</span>
        )}
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1.5 hover:bg-primary-foreground/10 rounded transition-colors"
          aria-label="Fermer l'annonce"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
